
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pertanyaan-umum/[topicId]/[topicItem]",
      function () {
        return require("private-next-pages/pertanyaan-umum/[topicId]/[topicItem].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pertanyaan-umum/[topicId]/[topicItem]"])
      });
    }
  